import * as ipo from './static/img/ipo.png';
import * as otc from './static/img/otc.png';
import * as daytrading from './static/img/daytrading.png';
import * as scalping from './static/img/scalping.png';
import * as tradingPsychology from './static/img/trading-psychology.png';

export const getBooks = (t: Function) => [
  {
    title: t('How to invest in IPO Investor Guide'),
    downloadLink:
      'https://s3.eu-central-1.amazonaws.com/investment-s3.unitedtraders.com/books/IPO_invest.pdf',
    titleHoverColor: 'blue',
    imgUrl: ipo,
  },

  {
    title: t('What OTC means and how to make money in it'),
    downloadLink:
      'https://s3.eu-central-1.amazonaws.com/investment-s3.unitedtraders.com/books/OTC_invest.pdf',
    titleHoverColor: 'green',
    imgUrl: otc,
  },

  {
    title: t('Psychology of trading the experienced trader’s lifehacks'),
    downloadLink:
      'https://s3.eu-central-1.amazonaws.com/investment-s3.unitedtraders.com/books/Psihologiya_torgovli-soveti_opitnogo_treidera.pdf',
    titleHoverColor: 'purple',
    imgUrl: tradingPsychology,
  },

  {
    title: t('Day trading intraday trading'),
    downloadLink:
      'https://s3.eu-central-1.amazonaws.com/investment-s3.unitedtraders.com/books/DayTrading-prakticheskoe_rukovodstvo_treidera.pdf',
    titleHoverColor: 'red',
    imgUrl: daytrading,
  },

  {
    title: t('Scalping practical guide'),
    downloadLink:
      'https://s3.eu-central-1.amazonaws.com/investment-s3.unitedtraders.com/books/Scalping-prakticheskoe_rukovodstvo_treidera.pdf',
    titleHoverColor: 'yellow',
    imgUrl: scalping,
  },
];
